import React, { Component, PureComponent } from "react";
import { Metric, Error } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading.js";
import PocketWatchHoursViewingWeeklyChart from "components/PocketWatch/PocketWatchHoursViewingWeeklyChart";

class RenderMetric extends PureComponent {
  render() {
    const { data, type, label, size, format } = this.props;

    return (
      <div className="mb-2 col-6 col-lg-3">
        <Heading size={6} className={"mb-2"}>
          {label}
        </Heading>
        <Metric {...data} size={size} type={type} format={format} />
      </div>
    );
  }
}

class PocketWatchHoursViewingWeeklySummary extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderMetrics = (data, metrics) =>
    Object.keys(data)
      .sort((a, b) => data[b].value - data[a].value)
      .filter((metricName) =>
        metrics.find((metric) => metric.name === metricName)
      )
      .map((metricName, key) => {
        // find the current metric from the metrics array
        const currentMetric = metrics.find(
          (metric) => metric.name === metricName
        );
        const metric_data = data[currentMetric.name];
        const label = currentMetric.label;
        const type = currentMetric.type || "number";
        const format = currentMetric.format;
        const size = key <= 3 ? "lg" : "md";

        return (
          <RenderMetric
            data={metric_data}
            type={type}
            label={label}
            size={size}
            format={format}
            key={key}
          />
        );
      });

  getExportData = () => {
    const { data, metrics } = this.props;
    return {
      data: metrics.map((metric) => ({
        Metric: metric.label,
        Value: !data.data[metric.name] ? "N/A" : data.data[metric.name].value,
      })),
      opts: {
        type: "other",
      },
    };
  };

  render() {
    const { data, metrics } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <>
        <div className="mt-4 mb-3 row mb-md-0 mt-md-0">
          {this.renderMetrics(data.data, metrics)}
        </div>
        <PocketWatchHoursViewingWeeklyChart data={data} />
      </>
    );
  }
}

export default PocketWatchHoursViewingWeeklySummary;
